import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "form-header"
};
const _hoisted_2 = { class: "form-header-flex" };
const _hoisted_3 = {
    key: 0,
    class: "header-left"
};
const _hoisted_4 = {
    key: 0,
    class: "title-content"
};
const _hoisted_5 = { class: "title" };
const _hoisted_6 = {
    key: 0,
    class: "subtitle"
};
const _hoisted_7 = {
    key: 1,
    class: "header-center"
};
const _hoisted_8 = {
    key: 2,
    class: "header-right"
};
const _hoisted_9 = { class: "form-content" };
import UDivider from "@/components/uikit/uComponents/UDivider.vue";
import { computed, useSlots } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UContent',
    props: {
        title: { default: "" },
        subtitle: { default: "" },
        hasTitleDelimiter: { type: Boolean, default: true },
        isCardBordered: { type: Boolean, default: false },
        headerPadding: { default: "0px 0px 15px 0px" },
        hasPadding: { type: Boolean, default: true },
        headerAlign: { default: "space-between" },
        titleAlign: { default: "left" }
    },
    setup(__props) {
        const props = __props;
        const slots = useSlots();
        const hasHeader = computed(() => !!slots["header-left"] ||
            !!slots["header-center"] ||
            !!slots["header-right"] ||
            !!slots["header"] ||
            !!slots["title"] ||
            !!slots["subtitle"] ||
            props.title ||
            props.subtitle);
        const hasTitleSlot = computed(() => !!slots.title);
        const hasSubtitleSlot = computed(() => !!slots.subtitle);
        const uStyle = computed(() => ({
            "--isCardBordered": props.isCardBordered
                ? "1px solid var(--color-70)"
                : "none",
            "--header-padding": props.headerPadding,
            "--header-align": props.headerAlign,
            padding: props.hasPadding ? "20px" : "0px"
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "card form-container",
                style: _normalizeStyle(uStyle.value)
            }, [
                (hasHeader.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "header", {}, () => [
                            _createElementVNode("div", _hoisted_2, [
                                (_ctx.$slots['header-left'] ||
                                    ((__props.title || hasTitleSlot.value) && !_ctx.$slots['header-center']))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _renderSlot(_ctx.$slots, "header-left", {}, () => [
                                            (__props.title || hasTitleSlot.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                    _createElementVNode("div", _hoisted_5, [
                                                        _renderSlot(_ctx.$slots, "title", {}, () => [
                                                            _createTextVNode(_toDisplayString(__props.title), 1)
                                                        ])
                                                    ]),
                                                    (__props.subtitle || hasSubtitleSlot.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                            _renderSlot(_ctx.$slots, "subtitle", {}, () => [
                                                                _createTextVNode(_toDisplayString(__props.subtitle), 1)
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.$slots['header-center'])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _renderSlot(_ctx.$slots, "header-center")
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.$slots['header-right'])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _renderSlot(_ctx.$slots, "header-right")
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        (__props.hasTitleDelimiter)
                            ? (_openBlock(), _createBlock(UDivider, {
                                key: 0,
                                class: "mt-3 mb-0"
                            }))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "content", {}, () => [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ])
            ], 4));
        };
    }
});
